module.exports = __webpack_public_path__ + "img/magento-migration_small.0ae00536.jpg";